import { HostListener, Component, Input, OnInit } from '@angular/core';

import {
    ViewController,
    AlertController,
    ModalController,
    LoadingController,
    ToastController,
    ModalOptions,
    NavParams
} from 'ionic-angular';

import { Horse } from '../../model/horse';
import { AlertMessager } from "../../lib/alertMessager";
import { HorseService } from "../../services/horse.service";
import { AccountHelper } from '../../lib/accountHelper';
import { ImageService } from '../../services/image.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserManager } from '../../services/managers/user.manager';
import { HorseOwner } from '../../model/horseOwner';
import { HorseBreeder } from '../../model/horseBreeder';
import { SearchComponent } from '../search/search.component';
import { HorsesAddEntityComponent } from './horses-add-entity.component';

@Component({
    selector: 'page-add-horse',
    templateUrl: 'add-horse.html'
})
export class AddHorsePage implements OnInit {
    @Input() horse: Horse;
    @Input() accountId: number | null;
    @Input() ownerRequired: boolean;

    editing = false;

    minDateForBirthDate: string;
    minSelectableDate: string;
    maxSelectableDate: string;

    sireName: string;
    damName: string;
    damSireName: string;
    ownerName: string;
    breederName: string;

    aqhaName: string = '';

    popoverActive = false;

    profileForm: FormGroup;
    submitAttempt: boolean;

    validationMessages: any[] = [];

    cogginsImageChanged: boolean;
    cogginsPictureUrl: any;
    cogginsBlob: any;
    cogginsExpiration: string;

    hasAQHA: boolean = true;
    aqhaErrored: boolean = false;

    dataLoaded: boolean = false;

    papersImageChanged: boolean;
    papersPictureUrl: any;
    papersBlob: any;
    viewImgUrl: string;
    private imageHostUrl = 'https://nextgenrodeomedia.blob.core.windows.net/images/';

    constructor(
        private userManager: UserManager,
        private loadingController: LoadingController,
        private viewController: ViewController,
        private topModal: ModalController,
        private imageService: ImageService,
        private alert: AlertMessager,
        private horseService: HorseService,
        private alertController: AlertController,
        private formBuilder: FormBuilder,
        private toastController: ToastController,
        private navParams: NavParams
    ) {
        this.accountId = navParams.get('accountId');
        this.horse = navParams.get('horse');

        if (this.horse && this.horse.birthDate && this.horse.birthDate.indexOf('T') != -1)
            this.horse.birthDate = this.horse.birthDate.substring(0, this.horse.birthDate.indexOf('T'));
    }

    async ngOnInit() {
        if (this.horse == null) {
            this.horse = new Horse();
            this.horse.cogginsFileName = '';
        }
        
        this.initForm();
        this.updateHorseInfo(this.horse);
    }

    enableAQHA(enableAQHA) {
        this.hasAQHA = enableAQHA;

        console.log("hasAQHA: ", this.hasAQHA);
    }

    async searchAQHA() {
        if (this.popoverActive) {
            return;
        }

        const loader = await this.loadingController.create({
            content: ("Searching AQHA for horse...")
        });

        await loader.present();

        try {
            let horseData: Horse;

            
            if (this.horse.aqhaId) {
                horseData = await this.horseService.searchHorseByAQHAId(this.horse.id, this.horse.aqhaId);
            } else {
                horseData = await this.horseService.searchHorseByAQHAName(this.horse.id, this.aqhaName);
            }

            console.log(horseData);

            if ((horseData as any).error) {
                if ((horseData as any).error == 'Invalid registration number.')
                    this.alert.showError("AQHA Service Error", (horseData as any).error);
                else {
                    this.alert.showError("AQHA Search Result", "AQHA Lookup Service is currently down.");
                }
            } else if (!horseData.name) {
                this.alert.showError("AQHA Search Result", "AQHA Lookup Service is currently down.");
            } else {
                var horseId = this.horse.id;
                this.horse = horseData;
                this.horse.id = horseId;
                this.updateHorseInfo(this.horse);
            }
        } catch (error) {
            this.alert.showError("AQHA Search Result", "AQHA Lookup Service is currently down.");
        }

        this.popoverActive = false;

        await loader.dismiss();
    }

    matchSexes(a: string, b: string) {
        return a.toLocaleLowerCase() == b.toLocaleLowerCase();
    }

    async updateHorseInfo(horse: Horse) {
        if (this.horse.id && !this.editing) {
            this.editing = true;

            const loader = await this.loadingController.create({
                content: ("Loading horse information...")
            });
    
            await loader.present();
    
            try {
                this.horse = await this.horseService.getHorseById(this.horse.id);
            } finally {
                loader.dismiss();
                this.dataLoaded = true;
            }

            console.log("finished loading horse info");
        } else {
            this.dataLoaded = true;
        }

        if (this.horse.cogginsExpirationDate) {
            this.cogginsExpiration = this.horse.cogginsExpirationDate.substring(0, this.horse.cogginsExpirationDate.indexOf('T'));
        }

        if (this.horse.birthDate && this.horse.birthDate.indexOf('T') != -1) {
            this.horse.birthDate = this.horse.birthDate.substring(0, this.horse.birthDate.indexOf('T'));
        }

        console.log('horse: ', horse);

        this.sireName = this.horse.sire ? this.horse.sire.name : null;
        this.damName = this.horse.dam ? this.horse.dam.name : null;
        this.damSireName = this.horse.dam && this.horse.dam.sire ? this.horse.dam.sire.name : null;
        this.ownerName = this.horse.owner ? this.horse.owner.name : null;
        this.breederName = this.horse.breeder ? this.horse.breeder.name : null;

        this.cogginsPictureUrl = this.imageHostUrl + this.horse.cogginsFileName;
        this.papersPictureUrl = this.imageHostUrl + this.horse.registrationPaperFileName;

        if (this.horse.cogginsExpirationDate && new Date(this.horse.cogginsExpirationDate) < new Date()) {
            this.minSelectableDate = this.horse.cogginsExpirationDate;
        } else {
            this.minSelectableDate = new Date().toISOString();
        }

        this.minDateForBirthDate = new Date(1900, 1).toISOString();
        this.minDateForBirthDate = this.minDateForBirthDate.substring(0, this.minDateForBirthDate.indexOf('T'));
        this.minSelectableDate = this.minSelectableDate.substring(0, this.minSelectableDate.indexOf('T'));
        const newDate = new Date();
        newDate.setFullYear(newDate.getFullYear() + 1);
        newDate.setDate(31);
        newDate.setMonth(12);
        this.maxSelectableDate = newDate.toISOString();
        this.maxSelectableDate = this.maxSelectableDate.substring(0, this.maxSelectableDate.indexOf('T'));
    }

    async save() {
        this.submitAttempt = true;

        if (this.profileForm.valid) {
            if (this.cogginsImageChanged) {
                console.log("cogginsChanged");
                try {
                    console.log({ cogginsBlob: this.cogginsBlob });
                    const data = await this.imageService.uploadImage(
                        this.cogginsBlob,
                        this.accountId + '_' + this.horse.id + '_horse_coggins_' + this.cogginsPictureUrl.substring(this.cogginsPictureUrl.lastIndexOf('/') + 1),
                        false
                    );
                    if ((data as any).message) {
                        this.alert.showError('Upload Image Failed', (data as any).message);
                    } else {
                        this.horse.cogginsFileName = data as string;
                    }
                } catch (err) {
                    this.alert.showError('Upload Image Error', err);
                }
            }

            if (this.papersImageChanged) {
                console.log("papersChanged");
                try {
                    const data = await this.imageService.uploadImage(
                        this.papersBlob,
                        this.accountId + '_' + this.horse.id + '_horse_papers_' + this.papersPictureUrl.substring(this.papersPictureUrl.lastIndexOf('/') + 1),
                        false
                    );
                    console.log({ imgResp: data });

                    if ((data as any).message) {
                        this.alert.showError('Upload Image Failed', (data as any).message);
                    } else {
                        this.horse.registrationPaperFileName = data as string;
                    }
                } catch (err) {
                    this.alert.showError('Upload Image Failed', err && err.message ? err.message : 'Please try again later.');
                }
            }

            this.saveHorse();
        } else {
            let toastMessage = "<ul>";

            this.validationMessages.forEach((validation) => {
                if (this.profileForm.get(validation.name).hasError(validation.type))
                    toastMessage += "<li>" + validation.message + "</li>";
            })

            toastMessage += "</ul>";

            this.toastController.create({
                message: toastMessage,
                cssClass: 'custom-error-toast',
                duration: 3000,
                position: 'bottom'

            }).present();
        }
    }

    saveHorse() {
        if (this.cogginsExpiration) {
            this.horse.cogginsExpired = new Date(this.cogginsExpiration) <= new Date();
            this.horse.cogginsExpirationDate = new Date(this.cogginsExpiration).toISOString();
        } else {
            this.horse.cogginsExpired = true;
        }

        if (!this.horse.sire && this.sireName && this.sireName.trim().length > 0) {
            this.horse.sire = new Horse();
            this.horse.sire.name = this.sireName;
        }

        if (!this.horse.dam && this.damName && this.damName.trim().length > 0) {
            this.horse.dam = new Horse();
            this.horse.dam.name = this.damName;
        }

        if (!this.horse.owner && this.ownerName && this.ownerName.trim().length > 0) {
            this.horse.owner = new HorseOwner();
            this.horse.owner.name = this.ownerName;
        }

        if (!this.horse.breeder && this.breederName && this.breederName.trim().length > 0) {
            this.horse.breeder = new HorseBreeder();
            this.horse.breeder.name = this.breederName;
        }

        this.horse.name = this.profileForm.value.name;
        this.horse.birthDate = new Date(this.profileForm.value.birthDate).toISOString();
        if (this.editing) {
            this.horseService.updateHorse(this.horse)
                .then((data: any) => {
                    if (data.message) {
                        this.alert.showError('Update Horse Error', data.message);
                    } else {
                        this.alert.showError('Success!', 'Your horse has been updated.');
                        data.cogginsExpired = this.horse.cogginsExpired; //bug fix for missing flag
                        this.close(data);
                    }
                }, error => {
                    this.alert.showError('Add Horse Error', error);
                });
        } else {
            this.horseService.addHorse(this.accountId, this.horse)
                .then((data: any) => {
                    if (data.message) {
                        this.alert.showError('Add Horse Error', data.message);
                    } else {
                        this.alert.showError('Success!', 'Your horse has been added.');
                        data.cogginsExpired = this.horse.cogginsExpired; //bug fix for missing flag
                        this.close(data);
                    }
                }, error => {
                    this.alert.showError('Add Horse Error', error);
                });
        }
    }

    showCoggins(horse) {
        if (this.popoverActive || !horse.cogginsFileName || horse.cogginsFileName === '') {
            return;
        }

        this.viewImgUrl = this.cogginsPictureUrl;
        this.popoverActive = true;
    }

    showPapers(horse) {
        if (this.popoverActive || !horse.registrationPaperFileName || horse.registrationPaperFileName === '') {
            return;
        }
        this.viewImgUrl = this.papersPictureUrl;
        this.popoverActive = true;
    }

    async delete() {
        if (this.popoverActive) {
            return;
        }

        this.popoverActive = true;

        const alert = await this.alertController.create({
            title: 'Confirm Horse Removal',
            message: 'Do you want to remove ' + this.horse.name + '?',
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => {
                        console.log('No clicked');
                    }
                },
                {
                    text: 'Yes',
                    handler: () => {
                        this.horseService.deleteHorse(AccountHelper.instance().token.id, this.horse.id)
                            .then(data => {
                                this.close({ delete: true });
                            }, error => this.alert.showError('Error Removing Horse', error));
                    }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        });
    }

    close(horse: any = null) {
        this.viewController.dismiss(horse);
    }

    async openSearchPopover(searchEntity: string) {
        let test = "";
        if (test) 
            return;

        const modal = await this.openModal(SearchComponent, {
            config: {
                searchTitle: `Search ${searchEntity}`,
                dynamicSearch: true,
                breederSearch: searchEntity === 'breeder',
                horseSearch: searchEntity === 'sire' || searchEntity === 'dam' || searchEntity === 'damSire',
                ownerSearch: searchEntity === 'owner',
            },
            siresOnly: searchEntity === 'sire',
            damsOnly: searchEntity === 'dam'
        }, {
            cssClass: 'app-search', enableBackdropDismiss: true
        });

        modal.onWillDismiss(async (searchData) => {
            if (searchData) {
                if (searchEntity == 'owner') {
                    if (!searchData.id) {
                        let newHorseOwner = new HorseOwner();
                        newHorseOwner.name = searchData.name;

                        this.openEditPopover(searchEntity, newHorseOwner);
                    } else {
                        this.horse.owner = searchData;
                        this.horse.ownerId = this.horse.owner.id;
                        this.ownerName = this.horse.owner.name;
                    }
                } else if (searchEntity == 'breeder') {
                    if (!searchData.id) {
                        let newHorseBreeder = new HorseBreeder();
                        newHorseBreeder.name = searchData.name;

                        this.openEditPopover(searchEntity, newHorseBreeder);
                    } else {
                        this.horse.breeder = searchData;
                        this.horse.breederId = this.horse.breeder.id;
                        this.breederName = this.horse.breeder.name;
                    }
                } else if (searchEntity == 'sire') {
                    if (!searchData.id) {
                        let newHorse = new Horse();
                        newHorse.name = searchData.name;
                        newHorse.sex = "Stallion";

                        const modal = await this.openModal(AddHorsePage, {
                            horse: newHorse
                        }, { cssClass: 'page-add-horse', enableBackdropDismiss: false }
                        );

                        modal.onDidDismiss(async (createData) => {
                            if (createData) {
                                this.horse.sire = createData;
                                this.sireName = this.horse.sire.name;
                            }
                        });
                    } else {
                        this.horse.sire = searchData;
                        this.horse.sireId = this.horse.sire.id;
                        this.sireName = this.horse.sire.name;
                    }
                } else if (searchEntity == 'dam') {
                    if (!searchData.id) {
                        let newHorse = new Horse();
                        newHorse.name = searchData.name;
                        newHorse.sex = "Mare";

                        const modal = await this.openModal(AddHorsePage, {
                            horse: newHorse
                        }, { cssClass: 'page-add-horse', enableBackdropDismiss: false }
                        );

                        modal.onDidDismiss(async (createData) => {
                            if (createData) {
                                this.horse.dam = createData;
                                this.damName = this.horse.dam.name;
                            }
                        });
                    } else {
                        this.horse.dam = searchData;
                        this.horse.damId = this.horse.dam.id;

                        if (this.horse.dam.sire) {
                            this.damSireName = this.horse.dam.sire.name;
                        }

                        this.damName = this.horse.dam.name;
                    }
                } else if (searchEntity == 'damSire') {
                    if (!searchData.id) {
                        let newHorse = new Horse();
                        newHorse.name = searchData.name;
                        newHorse.sex = "Stallion";

                        const modal = await this.openModal(AddHorsePage, {
                            horse: newHorse
                        }, { cssClass: 'page-add-horse', enableBackdropDismiss: false }
                        );

                        modal.onDidDismiss(async (createData) => {
                            if (createData) {
                                this.horse.dam.sire = searchData;
                                this.horse.dam.sireId = this.horse.dam.sire.id;
                                this.damSireName = this.horse.dam.sire.name;
                            }
                        });
                    } else {
                        this.horse.dam.sire = searchData;
                        this.horse.dam.sireId = this.horse.dam.sire.id;
                        this.damSireName = this.horse.dam.sire.name;
                    }
                }
            }
        })
    }

    async openEditPopover(searchEntity: string, editModel: any) {
        if (searchEntity == 'owner') {
            const modal = await this.openModal(HorsesAddEntityComponent, {
                horseOwner: editModel
            }, { cssClass: 'page-horse-add-entity', enableBackdropDismiss: false }
            );

            modal.onDidDismiss(createData => {
                if (createData) {
                    this.horse.owner = createData;
                    this.ownerName = this.horse.owner.name;
                }
            });
        } else {
            const modal = await this.openModal(HorsesAddEntityComponent, {
                horseBreeder: editModel
            }, { cssClass: 'page-horse-add-entity', enableBackdropDismiss: false }
            );

            modal.onDidDismiss(createData => {
                if (createData) {
                    this.horse.breeder = createData;
                    this.breederName = this.horse.breeder.name;
                }
            });
        }
    }

    private initForm() {
        let controlConfig = {
            name: [this.horse.name, [Validators.required, Validators.minLength(1)]],
            birthDate: [
                this.horse.birthDate,
                Validators.required
            ],
            ownerName: [this.ownerName]
        };

        if (this.ownerRequired)
            (controlConfig as any).ownerName = [this.ownerName, [Validators.required]];

        this.profileForm = this.formBuilder.group(controlConfig);

        this.validationMessages = [
            { name: 'name', type: 'required', message: 'Name is required.' },
            { name: 'birthDate', type: 'required', message: 'Foal date is required.' }
        ];

        if (this.ownerRequired)
            this.validationMessages.push({ name: 'ownerName', type: 'required', message: 'Owner is required.' });
    }

    private async openModal(component, models, opts: ModalOptions) {
        const modal = await this.topModal.create(component, models, {
            ...opts
        });

        await modal.present();

        return modal;
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (!this.viewController.isLast() || this.popoverActive || AlertMessager.showingAlert)
            return;

        if (ev.keyCode === 13) {
            this.saveHorse();
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/horse/add-horse.ts